import * as React from 'react';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';

import StatusContext from '../../../contexts/StatusContext'
import CommonTasksContext from '../../../contexts/CommonTasksContext'
import { PushButton } from '../pushbutton/PushButton';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

import { useRef, useEffect } from "react";
import { DisplayCustomPrompts } from './DisplayCustomPrompts';

export const DialogDisplayCustomPrompts = () => {
  
  const {
    changeLanguage,
} = React.useContext(StatusContext);

const {
  sortedPrompts,
  setAddPromptMode,
  displaycustompromptsdialog,
  setDisplayCustomPromptsDialog,
  setShowCustomPromptDialog,
  setCustomPrompt,
  statusCustomPrompts,
  
} = React.useContext(CommonTasksContext);

const promptAreaRef = useRef(null);

  useEffect(() => {

    if (promptAreaRef.current) {
      promptAreaRef.current.style.height = 'auto';
      promptAreaRef.current.style.height = `${promptAreaRef.current.scrollHeight}px`;
  }
}, [promptAreaRef]);


const onAddPrompt = () => {
 
  setAddPromptMode(true)
  setCustomPrompt({id:0, default: false, name: '', prompt: '' })
  setShowCustomPromptDialog(true)

}


const handleClose = () => {
  setDisplayCustomPromptsDialog(false);
};

  return (
   
    <React.Fragment>
   
        <Dialog
          open={displaycustompromptsdialog}
        
          PaperProps={{
            component: 'form',
            onSubmit: (event) => {
              event.preventDefault();
              const formData = new FormData(event.currentTarget);
              const formJson = Object.fromEntries(formData.entries());
              const email = formJson.email;
              console.log(email);
            
            },
          }}
          sx={{ '& .MuiDialog-paper': { width: '600px', maxWidth: '100%' } }} // Set fixed width here
        >

        <DialogTitle>{changeLanguage('common', 'dialogtitle_1')}</DialogTitle>

        <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
       <CloseIcon />
      </IconButton>
  
        <DialogContent dividers>
        <div className="customPromptsContainer">
              {
              <ul className="navbarNames">
                {
                  Array.isArray(sortedPrompts) &&
                  sortedPrompts.map((item, idx) => (
                    <DisplayCustomPrompts
                      key={`CustomPrompt${idx}`}
                      prompt={item}
                      seqid={idx + 1}
                      total={sortedPrompts.length}
                    

                    />
                  ))
                }
              </ul>
              }
          </div>
          <br></br>
          <div className="mainButtonsLeft">
              <PushButton onClick={onAddPrompt} label={changeLanguage('common', 'dialogadd')} />
          </div>

          <label>{statusCustomPrompts}</label>

    
        </DialogContent>
      </Dialog>
    </React.Fragment>
    
  );
  
}